var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"sp-contact",attrs:{"to":"/contact","exact":""}},[_c('span',[_vm._v(" お見積り"),_c('br'),_vm._v("デモ機貸出し"),_c('br'),_vm._v("お問い合わせ "),_c('br'),_vm._v("フォームへ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f701328","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/SpContact.vue
// module id = null
// module chunks = 